module.exports = __webpack_public_path__ + "img/img_back_ivory.c301caaf.png";